import React from 'react';

type MastercardIconProps = {
  size?: number;
  className?: string;
};

const MastercardIcon: React.FC<MastercardIconProps> = ({ size = 36, className }) => {
  const width = size;
  const height = Math.round((size * 40) / 64);
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 64 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      {/* two overlapping circles */}
      <circle cx="26" cy="20" r="14" fill="#EB001B" />
      <circle cx="38" cy="20" r="14" fill="#FF5F00" />
    </svg>
  );
};

export default MastercardIcon;


